export const countryCodes = {
  KW: 'Kuwait',
  KY: 'Cayman Islands',
  KZ: 'Kazakhstan',
  LA: 'Lao People`s Democratic Republic',
  AD: 'Andorra',
  LB: 'Lebanon',
  AE: 'United Arab Emirates',
  LC: 'Saint Lucia',
  AF: 'Afghanistan',
  LI: 'Liechtenstein',
  AG: 'Antigua and Barbuda',
  LK: 'Sri Lanka',
  AI: 'Anguilla',
  LR: 'Liberia',
  AL: 'Albania',
  LS: 'Lesotho',
  AM: 'Armenia',
  LT: 'Lithuania',
  AO: 'Angola',
  LU: 'Luxembourg',
  AP: 'Asia/Pacific Region',
  LV: 'Latvia',
  AQ: 'Antarctica',
  LY: 'Libyan Arab Jamahiriya',
  AR: 'Argentina',
  MA: 'Morocco',
  AS: 'American Samoa',
  MC: 'Monaco',
  AT: 'Austria',
  MD: 'Moldova, Republic of',
  AU: 'Australia',
  ME: 'Montenegro',
  AW: 'Aruba',
  MF: 'Saint Martin',
  AX: 'Aland Islands',
  MG: 'Madagascar',
  AZ: 'Azerbaijan',
  MH: 'Marshall Islands',
  BA: 'Bosnia and Herzegovina',
  MK: 'Macedonia',
  BB: 'Barbados',
  ML: 'Mali',
  BD: 'Bangladesh',
  MM: 'Myanmar',
  BE: 'Belgium',
  MN: 'Mongolia',
  BF: 'Burkina Faso',
  MO: 'Macao',
  BG: 'Bulgaria',
  MP: 'Northern Mariana Islands',
  BH: 'Bahrain',
  MQ: 'Martinique',
  BI: 'Burundi',
  MR: 'Mauritania',
  BJ: 'Benin',
  MS: 'Montserrat',
  BL: 'Saint Bartelemey',
  MT: 'Malta',
  BM: 'Bermuda',
  MU: 'Mauritius',
  BN: 'Brunei Darussalam',
  MV: 'Maldives',
  BO: 'Bolivia',
  MW: 'Malawi',
  BQ: 'Bonaire, Saint Eustatius and Saba',
  MX: 'Mexico',
  BR: 'Brazil',
  MY: 'Malaysia',
  BS: 'Bahamas',
  MZ: 'Mozambique',
  BT: 'Bhutan',
  NA: 'Namibia',
  BV: 'Bouvet Island',
  NC: 'New Caledonia',
  BW: 'Botswana',
  NE: 'Niger',
  BY: 'Belarus',
  NF: 'Norfolk Island',
  BZ: 'Belize',
  NG: 'Nigeria',
  CA: 'Canada',
  NI: 'Nicaragua',
  CC: 'Cocos (Keeling) Islands',
  NL: 'Netherlands',
  CD: 'Congo, The Democratic Republic of the',
  NO: 'Norway',
  CF: 'Central African Republic',
  NP: 'Nepal',
  CG: 'Congo',
  NR: 'Nauru',
  CH: 'Switzerland',
  NU: 'Niue',
  CI: 'Cote d`Ivoire',
  NZ: 'New Zealand',
  CK: 'Cook Islands',
  OM: 'Oman',
  CL: 'Chile',
  PA: 'Panama',
  CM: 'Cameroon',
  PE: 'Peru',
  CN: 'China',
  PF: 'French Polynesia',
  CO: 'Colombia',
  PG: 'Papua New Guinea',
  CR: 'Costa Rica',
  PH: 'Philippines',
  CU: 'Cuba',
  PK: 'Pakistan',
  CV: 'Cape Verde',
  PL: 'Poland',
  CW: 'Curacao',
  PM: 'Saint Pierre and Miquelon',
  CX: 'Christmas Island',
  PN: 'Pitcairn',
  CY: 'Cyprus',
  PR: 'Puerto Rico',
  CZ: 'Czech Republic',
  PS: 'Palestinian Territory',
  DE: 'Germany',
  PT: 'Portugal',
  DJ: 'Djibouti',
  PW: 'Palau',
  DK: 'Denmark',
  PY: 'Paraguay',
  DM: 'Dominica',
  QA: 'Qatar',
  DO: 'Dominican Republic',
  RE: 'Reunion',
  DZ: 'Algeria',
  RO: 'Romania',
  EC: 'Ecuador',
  RS: 'Serbia',
  EE: 'Estonia',
  RU: 'Russian Federation',
  EG: 'Egypt',
  RW: 'Rwanda',
  EH: 'Western Sahara',
  SA: 'Saudi Arabia',
  ER: 'Eritrea',
  SB: 'Solomon Islands',
  ES: 'Spain',
  SC: 'Seychelles',
  ET: 'Ethiopia',
  SD: 'Sudan',
  EU: 'Europe',
  SE: 'Sweden',
  FI: 'Finland',
  SG: 'Singapore',
  FJ: 'Fiji',
  SH: 'Saint Helena',
  FK: 'Falkland Islands (Malvinas)',
  SI: 'Slovenia',
  FM: 'Micronesia, Federated States of',
  SJ: 'Svalbard and Jan Mayen',
  FO: 'Faroe Islands',
  SK: 'Slovakia',
  FR: 'France',
  SL: 'Sierra Leone',
  GA: 'Gabon',
  SM: 'San Marino',
  GB: 'United Kingdom',
  SN: 'Senegal',
  GD: 'Grenada',
  SO: 'Somalia',
  GE: 'Georgia',
  SR: 'Suriname',
  GF: 'French Guiana',
  SS: 'South Sudan',
  GG: 'Guernsey',
  ST: 'Sao Tome and Principe',
  GH: 'Ghana',
  SV: 'El Salvador',
  GI: 'Gibraltar',
  SX: 'Sint Maarten',
  GL: 'Greenland',
  SY: 'Syrian Arab Republic',
  GM: 'Gambia',
  SZ: 'Swaziland',
  GN: 'Guinea',
  TC: 'Turks and Caicos Islands',
  GP: 'Guadeloupe',
  TD: 'Chad',
  GQ: 'Equatorial Guinea',
  TF: 'French Southern Territories',
  GR: 'Greece',
  TG: 'Togo',
  GS: 'South Georgia and the South Sandwich Islands',
  TH: 'Thailand',
  GT: 'Guatemala',
  TJ: 'Tajikistan',
  GU: 'Guam',
  TK: 'Tokelau',
  GW: 'Guinea-Bissau',
  TL: 'Timor-Leste',
  GY: 'Guyana',
  TM: 'Turkmenistan',
  HK: 'Hong Kong',
  TN: 'Tunisia',
  HM: 'Heard Island and McDonald Islands',
  TO: 'Tonga',
  HN: 'Honduras',
  TR: 'Turkey',
  HR: 'Croatia',
  TT: 'Trinidad and Tobago',
  HT: 'Haiti',
  TV: 'Tuvalu',
  HU: 'Hungary',
  TW: 'Taiwan',
  ID: 'Indonesia',
  TZ: 'Tanzania, United Republic of',
  IE: 'Ireland',
  UA: 'Ukraine',
  IL: 'Israel',
  UG: 'Uganda',
  IM: 'Isle of Man',
  UM: 'United States Minor Outlying Islands',
  IN: 'India',
  US: 'United States',
  IO: 'British Indian Ocean Territory',
  UY: 'Uruguay',
  IQ: 'Iraq',
  UZ: 'Uzbekistan',
  IR: 'Iran, Islamic Republic of',
  VA: 'Holy See (Vatican City State)',
  IS: 'Iceland',
  VC: 'Saint Vincent and the Grenadines',
  IT: 'Italy',
  VE: 'Venezuela',
  JE: 'Jersey',
  VG: 'Virgin Islands, British',
  JM: 'Jamaica',
  VI: 'Virgin Islands, U.S.',
  JO: 'Jordan',
  VN: 'Vietnam',
  JP: 'Japan',
  VU: 'Vanuatu',
  KE: 'Kenya',
  WF: 'Wallis and Futuna',
  KG: 'Kyrgyzstan',
  WS: 'Samoa',
  KH: 'Cambodia',
  YE: 'Yemen',
  KI: 'Kiribati',
  YT: 'Mayotte',
  KM: 'Comoros',
  ZA: 'South Africa',
  KN: 'Saint Kitts and Nevis',
  ZM: 'Zambia',
  KP: 'Korea, Democratic People`s Republic of',
  ZW: 'Zimbabwe',
  KR: 'Korea, Republic of'
};
